import api from '../services/config/api';

interface IRegisterLP {
  company: string;
  name: string;
  email: string;
  infoEmail: boolean;
}

export const createRegisterLP = (data: IRegisterLP) => {
  return api.post('user-lp/save', data);
};

interface ICreateByUserLP {
  company: string;
  createdAt: string | Date;
  email: string;
  id: number;
  infoEmail: boolean;
  name: string;
}

export const createFirsStepSimulation = (
  accessToken: string,
  createdByUserLP?: ICreateByUserLP,
) => {
  return api.post<{ id: number }>(
    'simulacao_multa/save_lp',
    {
      createdByUserLP,
      id: 0,
    },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    },
  );
};

export const createSecondStepSimulation = (id: string, data: any, accessToken: string) => {
  return api.put<{ valorSimulado: number }>(`simulacao_multa/${id}`, data, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};
